import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, IconButton, Input, InputGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function CartNavbar() {
  return (
    <Box pos="fixed" top={0} w="full" h="16" bgColor="#2563EB" zIndex={1}>
      <Box display="flex" p="3">
        <Link to="/">
          <IconButton variant="ghost" color="white">
            <ArrowBackIcon />
          </IconButton>
        </Link>
        <Text color="white" display="flex" alignItems="center">
          Keranjang
        </Text>
      </Box>
    </Box>
  );
}
